module.exports = __webpack_public_path__ + "img/Banner_Feria_del_Trabajo_2023.c240bd6b.png";